<div class="modal__header mb-0">
  <div class="modal__title">
    <i class="fa-solid fa-arrow-up-from-bracket"></i>
    UPLOAD DOCUMENTS
  </div>
  <div class="modal__close" (click)="close();">
    <i class="fas fa-times"></i>
  </div>
</div>
<div class="modal__content">
  <input #uploadInput style="display: none" type="file" ng2FileSelect multiple
    [uploader]="uploader"
    [accept]="uploadInputAccept"/>
  <div class="file-drop-area">
    <div
      ng2FileDrop
      [ngClass]="{'drop-zone-div': true, 'file-over': fileDragOver, 'disabled-drop-zone': uploadedFiles.length === FILE_UPLOAD_LIMIT}"
      (fileOver)="fileOverDropZone($event)"
      [uploader]="uploader"
      >
      <div class="file-drop-area-text-container">
        @if (uploadedFiles.length < FILE_UPLOAD_LIMIT) {
          <i class="fa fa-file-arrow-up upload-file-icon"></i>
          <div class="dropzone-text-line-1"><a class="text-primary" (click)="openFilePicker()">Select</a> or drag and drop up to 10 files.</div>
          <div>Maximum file size is 5 GB.</div>
          @if (fileNotSelectedError) {
            <div class="error-text">
              Please select a file
            </div>
          }
        } @else {
          <div class="disabled-drop-zone-text">
            The maximum amount of documents that can be uploaded at once has been reached.
          </div>
        }
      </div>
    </div>
  </div>

  <div class="selected-doc-table">
    <table class="table">
      <thead>
        <tr>
          <th class="col-md-5">Document Name</th>
          <th class="col-md-5">Type of Statement</th>
          @if (showCombineDocumentFeature) {
            <th class="col-md-combine">Combine <i class="fas fa-info-circle" data-bs-toggle="tooltip" data-bs-placement="top" title="Use this feature to combine two or more documents into one statement so they can be processed and spread as a single file."></i></th>
          }
          <th class="col-md-1 right-align-label">{{fileUploadProcessBegun ? 'Status' : 'Actions'}}</th>
        </tr>
      </thead>
      <tbody>
        @for (uploadedFile of uploadedFiles; track uploadedFile; let i = $index) {
          <tr #uploadedDocumentRows
            file-item-tr
            [uploadedFile]="uploadedFile"
            [fileUploadProcessBegun]="fileUploadProcessBegun"
            [combineDisabled]="uploadedFiles.length <= 1"
            [taxFormOptions]="taxFormOptions"
            [showPuertoRicoCorporate]="showPuertoRicoCorporate"
            [showPuertoRicoIndividual]="showPuertoRicoIndividual"
            [customAttrDefinitions]="customAttrDefinitions"
            [showCombineFeature]="showCombineDocumentFeature"
            (removeFile)="removeFile(i, uploadedFile.fileItem)"
            (combineChange)="handleCombineChange(uploadedFile, $event)"
            (docTypeChange)="validateCombination()"
          ></tr>
        }
        @if (!uploadedFiles?.length) {
          <tr>
            <td class="empty-state-row" colspan="4">
              No documents selected
            </td>
          </tr>
        }
      </tbody>
    </table>

    @if (hasFilesWithNamesTooLong()) {
      <div class="file-name-length-error">
        {{ fileNameTooLongError }}
      </div>
    }

    <!-- Begin: Combination Summary Section -->
    @if (showCombineDocumentFeature && getCombinedFiles().length > 0) {
      <div
        class="combination-summary"
        [ngClass]="{'has-errors': hasCombinationErrors()}">
        <div class="combination-summary-header">
          <div class="combination-summary-title">
            <i class="fa-solid fa-layer-group"></i>
            <span>Combination Summary</span>
          </div>
          <i class="fas fa-info-circle"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
          title="The uploaded statements will display as a single combined file in the same order they were selected."></i>
        </div>
        <ul class="combination-file-list">
          @for (file of getCombinedFiles(); track file) {
            <li appFsMask>
              {{ file.fileItem.file.name }}
            </li>
          }
        </ul>
        <div class="combination-file-name-section">
          <label class="control-label" for="combinedFileName">
            File Name (Character Limit: 200)
          </label>
          <div class="input-group">
            <input
              id="combinedFileName"
              type="text"
              class="form-control"
              [ngClass]="{'is-invalid': !isFileNameValid()}"
              [value]="combinedFileName"
              (input)="onCombinedFileNameChange($any($event.target).value)"
              [disabled]="fileUploadProcessBegun"
              [attr.maxlength]="200 - combinedFileExtension.length" />
            <span class="input-group-text file-type-suffix">{{ combinedFileExtension }}</span>
          </div>
        </div>
      </div>
    }
    @if (showCombineDocumentFeature && hasCombinationErrors()) {
      <div class="combination-errors">
        @for (error of combinationErrors; track error) {
          <div class="error-message">
            {{ error }}
          </div>
        }
      </div>
    }
    <!-- End: Combination Summary Section -->
  </div>
</div>
<div class="modal__footer">
  @if (showDocumentUploadWarning) {
    <div class="document-upload-warning-strip" data-test="document-upload-warning">
      <i class="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>
      <span class="document-upload-warning-text"><strong>IMPORTANT:</strong> {{ documentUploadWarningText }}</span>
    </div>
  }
  <div class="footer-action-container">
    <button type="reset" class="btn btn-empty-primary upload-footer"
    (click)="close();">{{fileUploadProcessBegun ? 'Close' : 'Cancel'}}</button>
    <button type="submit" class="btn btn-primary upload-footer" [disabled]="fileUploadProcessBegun"
      (click)="submitUploadedFiles()">
      Upload
      @if (fileUploadProcessBegun) {
        <div class="loader button-loader"></div>
      }
    </button>
  </div>
</div>
